import { defineExtension } from "lexical";
import { RichTextExtension } from "@lexical/rich-text";
import { ListExtension } from "@lexical/list";
import { LinkExtension } from "@lexical/link";
import { TableExtension } from "@lexical/table";
import { HistoryExtension } from "@lexical/history";

import { theme } from "../theme";

export const BaseExtension = defineExtension({
    name: "@motimatic/rich-text-editor/base",
    namespace: "motimatic-rich-text-editor",
    theme,
    dependencies: [
        RichTextExtension,
        ListExtension,
        LinkExtension,
        TableExtension,
        HistoryExtension,
    ],
    onError(error: Error) {
        console.error("[MotiRichTextEditor]", error);
    },
});
